/* global axios */
import ApiClient from './ApiClient';

class ConversionsApi extends ApiClient {
  constructor() {
    super('conversions', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  analytics(params = {}) {
    return axios.get(`${this.url}/analytics`, { params });
  }

  pipelinePerformance(params = {}) {
    return axios.get(`${this.url}/pipeline_performance`, { params });
  }
}

class ConversionTypesApi extends ApiClient {
  constructor() {
    super('conversion_types', { accountScoped: true });
  }

  list() {
    return axios.get(this.url);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export const conversionsApi = new ConversionsApi();
export const conversionTypesApi = new ConversionTypesApi();
